import { CommonModule } from '@angular/common';
import { Component, OnInit, input, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule, Router, NavigationEnd } from '@angular/router';

import { SidebarMenuItems } from '@app/layout/sidebar/sidebar.model';
import { RoleBasedAccessDirective } from '@app/shared/directives/role-based-access/role-based-access.directive';

@Component({
  selector: 'app-sidebar-menu',
  imports: [CommonModule, MatIconModule, MatListModule, RouterModule, RoleBasedAccessDirective],
  templateUrl: './sidebar-menu.component.html',
  styles: ['mat-nav-list {height: calc(100vh - 325px)}'],
})
export class SidebarMenuComponent implements OnInit {
  private router = inject(Router);

  sidebarMenuItems = input<SidebarMenuItems[]>([]);

  activeSubmenuTitle: string | null = null;
  currentUrl: string = '';

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        this.setActiveSubmenuBasedOnRoute();
      }
    });
  }

  ngOnInit() {
    this.setActiveSubmenuBasedOnRoute();
  }

  setActiveSubmenuBasedOnRoute() {
    for (const item of this.sidebarMenuItems()) {
      if (item.submenu) {
        const isActive = item.submenu.some(subItem => subItem.link && this.currentUrl.startsWith(subItem.link));
        if (isActive) {
          this.activeSubmenuTitle = item.title;
          break;
        }
      }
    }
  }

  toggleSubmenu(item: SidebarMenuItems, event: Event) {
    event.stopPropagation();
    if (item?.submenu) {
      this.activeSubmenuTitle = this.activeSubmenuTitle === item.title ? null : item.title;
    } else {
      this.activeSubmenuTitle = null;
    }
  }

  isParentActive(item: SidebarMenuItems): boolean {
    if (item?.submenu) {
      return item.submenu.some(subItem => {
        if (!subItem.link) return false;
        return this.currentUrl === subItem.link || this.currentUrl.startsWith(subItem.link + '/');
      });
    }
    return false;
  }

  isLinkActive(link: string | null): boolean {
    return link ? this.currentUrl.startsWith(link) : false;
  }
}
